var map = {
	"./CategoryList": [
		99709,
		5547
	],
	"./CategoryList.vue": [
		99709,
		5547
	],
	"./RestaurantList": [
		91309,
		3310
	],
	"./RestaurantList.vue": [
		91309,
		3310
	],
	"./tests/CategoryList.spec": [
		56152,
		6152
	],
	"./tests/CategoryList.spec.js": [
		56152,
		6152
	],
	"./tests/RestaurantList.spec": [
		89965,
		9965
	],
	"./tests/RestaurantList.spec.js": [
		89965,
		9965
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2814;
module.exports = webpackAsyncContext;